<ng-container *ngIf="size === 'small'">
  <a mat-flat-button class="mat-button-extra-small"
     color="grey"
     [href]="file?.downloadUrl"
     target="_blank">
    <raf-icon icon="file-pdf"></raf-icon>{{file?.name}}
  </a>
</ng-container>

<ng-container *ngIf="size === 'medium'">
  <a [href]="file?.downloadUrl" target="_blank" class="stack stack-horizontal stack-center grey-text">
    <raf-icon icon="file-pdf" size="32px"></raf-icon>
    <raf-text [link]="true" variant="body-large" weight="medium" color="grey-text">{{file?.name}} ({{file?.size}})</raf-text>
  </a>
</ng-container>
